module.exports = __webpack_public_path__ + "media/bootstrap-icons/ui-checks-grid-5eb188e7.svg";